import React, { useCallback, useEffect, useState } from 'react';
import { Box, Button } from '@mui/material';
import { ArrowUpwardRounded, ArrowDownwardRounded, Clear } from '@mui/icons-material';
import { drawChart } from '../chartUtils.js';
import { useChartData } from './ChartDataProvider';

export default function CanvasView({ canvasRef }) {
  const {
    data,
    knitdata,
    rows,
    cols,
    colors,
    settings,
    selectedColorway,
    shapes
  } = useChartData();
  
  const [currentRow, setCurrentRow] = useState(-1);

  const onDrawChart = useCallback(() => {
    drawChart({ 
      canvasRef, 
      settings, 
      cols, 
      rows, 
      data, 
      colors, 
      currentRow, 
      colorway: selectedColorway, 
      knitdata, 
      stitchPreview: null, 
      colorPreview: null,
      shapes,
      currentShapePreview: null,
      selectedShape: null
    });
  }, [canvasRef, settings, cols, rows, data, colors, currentRow, selectedColorway, knitdata, shapes]);

  useEffect(() => {
    onDrawChart();
  }, [onDrawChart]);

  function handleStart(event) {
    const rect = canvasRef.current.getBoundingClientRect();
    const y = event.clientY || event.touches[0].clientY;
    
    // Calculate margins based on label settings
    const { showLabels = { right: true, left: false, top: false, bottom: true } } = settings;
    const margin = settings.margin || 24; // Use configurable margin
    const shapeMargin = 50; // Shape margin around the canvas
    const topMargin = showLabels.top ? margin : 0;
    
    // Account for shape margin in coordinate calculation
    const row = Math.floor((y - rect.top - shapeMargin - topMargin) / settings.cellSize / settings.yscale);
    
    // Only set current row if it's within valid grid boundaries
    if (row >= 0 && row < rows) {
      setCurrentRow(row);
    }
  }

  const handlePrevRow = () => {
    setCurrentRow((prevRow) => (prevRow + 1) % rows);
  };

  const handleNextRow = () => {
    setCurrentRow((prevRow) => (prevRow - 1 + rows) % rows);
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Box sx={{ overflowX: 'auto', p: 1 }}>
        <canvas ref={canvasRef} onMouseDown={handleStart} onTouchStart={handleStart} />
      </Box>
      <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
        <Button variant="outlined" startIcon={<ArrowDownwardRounded />} onClick={handlePrevRow}>
          Previous
        </Button>
        <Button variant="outlined" startIcon={<Clear />} onClick={() => setCurrentRow(-1)}>
          Clear
        </Button>
        <Button variant="outlined" startIcon={<ArrowUpwardRounded />} onClick={handleNextRow}>
          Next
        </Button>
      </Box>
    </Box>
  );
}
